<template>
  <nx-bform
    ref="form"
    @submit="onSubmit"
    class="e-registration-helper-register-form"
  >
    <h5>
      {{ $t("title") }}
    </h5>
    <p class="text-muted">
      {{ $t("titleDesc") }}
    </p>

    <nx-bform-server-errors />
    <div v-if="!isCompleted">
    

      <template >
        <RegistrationLoginNameFormGroup
          label-cols="2"
          label-align="right"
          required
          v-model="form.username"
        />

        <RegistrationPasswordFormGroup
          label-cols="2"
          label-align="right"
          required
          v-model="form.password"
        />
        

 <ManageCertResetFormGroup  label-align="right"  :invitationKey="invitationKey" :name="fullName" :guid="guid" @setName="setName"  label-cols="2" />

       

        <CaptchaFormGroup
          label-cols="2"
          label-align="right"
          v-model="form.captcha"
          @change-token="form.captchaToken = $event.token"
          required
        />

        <hr />


        <b-form-group label-cols="2">
          <b-button type="submit" variant="primary" v-t="'send'" />
          <b-button class="ml-2" @click="resetForm" v-t="'cancel'" />
        </b-form-group>
      </template>
    </div>
     <AfterRegisterCompleted v-if="isCompleted" :exist="true"  @useESS="useESS"/>
    <!--<div v-else style="color:red">
      <div v-if="result=='Expired'">
        {{ $t("InvitationExpired") }}
      </div>
      <div v-else-if="result=='NotFound'">
        {{ $t("InvitationNotFound") }}
      </div>      
      <div v-else-if="result=='Registered'">
        {{ $t("Registered") }}
      </div>  
    </div>-->    
  </nx-bform>
</template>

<script>
import NxFormCaptcha from "@/components/NxFormCaptcha";
import {EshApi, MemberRegistrationApi, RequestRegistrationApi } from "@/api";
import { UserService } from "@/services";
import { FileUtil, UserApi } from "nx-libs";
import RegistrationPasswordFormGroup from "@/forms/registration/RegistrationPasswordFormGroup";
import RegistrationHaveEshAcFormGroup from "@/forms/registration/RegistrationHaveEshAcFormGroup";
import RegistrationLoginNameFormGroup from "@/forms/registration/RegistrationLoginNameFormGroup";
import RegistrationNameTitleFormGroup from "@/forms/registration/RegistrationNameTitleFormGroup";
import RegistrationSurnameFormGroup from "@/forms/registration/RegistrationSurnameFormGroup";
import RegistrationGivenNameFormGroup from "@/forms/registration/RegistrationGivenNameFormGroup";
import RegistrationEnglishNameFormGroup from "@/forms/registration/RegistrationEnglishNameFormGroup";
import RegistrationChineseNameFormGroup from "@/forms/registration/RegistrationChineseNameFormGroup";
import RegistrationHKIDNumberFormGroup from "@/forms/registration/RegistrationHKIDNumberFormGroup";
import RegistrationEmailFormGroup from "@/forms/registration/RegistrationEmailFormGroup";
import RegistrationTelephoneFormGroup from "@/forms/registration/RegistrationTelephoneFormGroup";
import RegistrationLanguageFormGroup from "@/forms/registration/RegistrationLanguageFormGroup";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import RegistrationContactAddressFormGroup from "@/forms/registration/RegistrationContactAddressFormGroup";
import RegistrationESignatureFormGroup from "@/forms/registration/RegistrationESignatureFormGroup";
import ManageCertResetFormGroup from '@/pages/manage-cert/components/ManageCertResetFormGroup.vue';
import AfterRegisterCompleted from '@/public/modules/login/components/login/AfterRegisterCompleted.vue';
import { v4 as uuidv4 } from 'uuid';
import { translateResponseError } from "@/utils/translate-response-error";

export default {
  props: {
    invitationKey: {
      type: String,
    },
    businessId :{
      type: String
    }
  },
  components: {
    NxFormCaptcha,
    RegistrationHaveEshAcFormGroup,
    RegistrationLoginNameFormGroup,
    RegistrationNameTitleFormGroup,
    RegistrationSurnameFormGroup,
    RegistrationGivenNameFormGroup,
    RegistrationEnglishNameFormGroup,
    RegistrationChineseNameFormGroup,
    RegistrationHKIDNumberFormGroup,
    RegistrationEmailFormGroup,
    RegistrationTelephoneFormGroup,
    RegistrationLanguageFormGroup,
    CaptchaFormGroup,
    RegistrationContactAddressFormGroup,
    RegistrationPasswordFormGroup,
    RegistrationESignatureFormGroup,
    ManageCertResetFormGroup,
    AfterRegisterCompleted
  },
  data() {
    return {
      haveAc: true,
      form: this.getForm(),
      accepted: false,
      validCode: false,
      result: [],
      nameEngDisable:false,
      guid:uuidv4(),
      fullName:"",
      isCompleted:false
    };
  },
  watch: {
    "form.surname": {
      handler(surname) {
        this.fullName = this.getFullName();
      },
      immediate: true
    },
    "form.givenName": {
      handler(givenName) {
        
        this.fullName = this.getFullName();
      },
      immediate: true
    }
  },
  async created(){
    if(this.invitationKey==null) this.invitationKey=this.$route.query.key;
    /*var res = await RequestRegistrationApi.validateInvitationCode(this.invitationKey)
    this.result = res.data;
    if(this.result == 'Valid')
    {
      this.validCode = true;
    }*/
  },
  methods: {
    getForm() {
      return {
        username: "",
        password: "",
        nameEng: "",
        title: "Mr",
        surname: "",
        givenName: "",
        nameChinese: "",
        address: "",
        email: "",
        telephone: "",
        lang: "en",
        captcha: "",
        captchaToken: "",
        accepted: false,
        idNo: "",
      };
    },
    resetForm() {
      this.form = this.getForm();
      this.$refs.form.reset(); 
      this.$router.push({
        name:"Login"});
    },
    async onSubmit() {
      const {  invitationKey, form } = this;

     
        try{
          await MemberRegistrationApi.resetCertification({
            LdapID:5,
            Username: form.username,
            Password: form.password,
            BusinessID: invitationKey,
            MemberCertificationGUID:this.guid
          });
          this.isCompleted=true;
          // await UserApi.login(5, {
          //   Username: form.username,
          //   Password: form.password,
          // });

          //UserService.redirectToLanding("prof");
        }
         catch ({response}) {
            if (response&&response.data) {
              console.log("response",response.data);
              this.$dangerToast(
                "Registration Error",
                translateResponseError(this, response.data)
              );
            }
          } 
       
        
      
    },
    setName(isDisable)
    {
      this.nameEngDisable = isDisable;
    },
    getFullName()
    {
        return this.form.surname.trim() +" " +this.form.givenName.trim();
    },
    useESS() {
      this.$router.push({ name: 'Login' });
    }
  },
};
</script>

<style lang="scss" scoped></style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/locales/responseMsg.locale"></i18n>

<i18n>
{
  "en": {
    "title": "Reset Digital Certificate",
    "titleDesc": "Please complete the following application form. All fields with (*) are mandatory.",
    "helperLogin": "Login as Collaborator",
    "InvitationNotFound": "Invitation code not found or has been cancelled",
    "InvitationExpired": "Invitation code expired",
    "InvitationRegistered": "Invitation Code already registered"
  },
  "zh_hk": {
    "title": "重設數碼證書",
    "titleDesc": "請填寫以下申請表格。帶（*）的所有字段均為必填項。",
    "helperLogin": "以助理身份登錄",
    "InvitationNotFound": "邀請碼無效或已被取消",
    "InvitationExpired": "邀請碼已過期",
    "InvitationRegistered": "邀請碼已被使用"    
  },
  "zh_cn": {
    "title": "重设数码证书",
    "titleDesc": "请填写以下申请表格。带（*）的所有字段均为必填项。",
    "helperLogin": "以助理身份登录",
    "InvitationNotFound": "邀请码无效或已被取消",
    "InvitationExpired": "邀请码已过期",
    "InvitationRegistered": "邀请码已被使用"
  }
}
</i18n>
